import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-tentacles',
  templateUrl: './magic-uses-tentacles.component.html',
  styleUrls: ['./magic-uses-tentacles.component.css']
})
export class MagicUsesTentaclesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
